/*eslint-disable */
import SecurityTable from "./SecurityTable";

export default SecurityTable;
